import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { SetContextLink } from '@apollo/client/link/context';
import { OidcService } from '@hawaii-framework/oidc-implicit-core';
import { DEFAULT_OIDC_SCOPES } from 'config/app.config';
import { appSettings } from 'config/app.settings';
import { SESSION_STORAGE_KEYS, SessionStorage } from 'utils/storage';

const httpLink = new HttpLink({
  uri: appSettings.ENV_GRAPHQL_BASE_URL_ONE_APP,
});

const contextLink = new SetContextLink((prevContext) => {
  const token = OidcService.getStoredToken({ scopes: DEFAULT_OIDC_SCOPES });

  return {
    uri: appSettings.ENV_GRAPHQL_BASE_URL_ONE_APP,
    headers: {
      ...prevContext.headers,
      Authorization: token ? OidcService.getAuthHeader(token) : undefined,
      agentId: SessionStorage.get(SESSION_STORAGE_KEYS.agentId) || '',
      'client-id': 'mijn-ziggo-web',
      'client-version': '1.0.0',
      'tx-id': crypto.randomUUID(),
      'Correlation-Id': crypto.randomUUID(),
    },
  };
});

const client = new ApolloClient({
  link: contextLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
